// extracted by mini-css-extract-plugin
export default {"authButtonContainer":"AuthButton-module__authButtonContainer_GJGTs","shineBehind":"AuthButton-module__shineBehind_cFTyL","authButton":"AuthButton-module__authButton_E9dJ7"};